import axios from 'axios';
import { API_URL } from '../config';

// Единый API-клиент: токен подставляется автоматически; при 401 тихо обновляем
// access-токен по refresh-токену (Epic 6) и повторяем запрос.
// ГЛАВНОЕ ПРАВИЛО: сессию убиваем ТОЛЬКО когда сервер однозначно сказал, что
// она мертва (400/401/403 на сам refresh) или refresh-токена нет вовсе.
// Любой другой 401 — временная накладка: отдаём ошибку странице и живём дальше.
const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

const clearAndLogin = (reason) => {
    console.warn('[auth] signing out:', reason);
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user_role');
    window.location.href = '/login';
};

// Один refresh на все одновременные 401 — параллельные запросы ждут его же.
let refreshing = null;

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { response, config } = error;
        if (response?.status !== 401 || !config || window.location.pathname === '/login') {
            return Promise.reject(error);
        }
        const url = config.url || '';
        // Сам логин/refresh обрабатывают свои ошибки сами.
        if (url.includes('/api/login') || url.includes('/api/refresh')) {
            return Promise.reject(error);
        }
        // Запрос уже повторяли после обновления токена. Второй 401 подряд
        // бывает при гонке параллельных запросов (поиск по мере ввода шлёт
        // пачку сразу) — это НЕ повод разлогинивать: отдаём ошибку странице.
        if (config._retried) {
            return Promise.reject(error);
        }
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            clearAndLogin('no refresh token');
            return Promise.reject(error);
        }
        try {
            refreshing = refreshing
                || axios.post(`${API_URL}/api/refresh`, { refreshToken }, { timeout: 15000 });
            const { data } = await refreshing;
            refreshing = null;
            if (!data || !data.token) throw new Error('refresh returned no token');
            localStorage.setItem('token', data.token);
            config._retried = true;
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${data.token}`;
            return api(config);
        } catch (refreshErr) {
            refreshing = null;
            const status = refreshErr.response?.status;
            if ([400, 401, 403].includes(status)) {
                clearAndLogin(`refresh rejected (${status})`);
            }
            // 5xx, 429, обрыв сети, кривой ответ — временное: токены целы,
            // повторим при следующем 401.
            return Promise.reject(error);
        }
    }
);

export default api;
